module.exports = __webpack_public_path__ + "static/media/Image2.29fb5cab.svg";